import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  TemplateRef
} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {ExcSigninService} from 'exc-signin';
import {ExcFileItem} from '../attachments/models/ExcFileItem';
import {DataImportEditMailModalComponent} from '../data-import-edit-mail-modal/data-import-edit-mail-modal.component';
import {DataImportUploadConfirmModalComponent} from '../data-import-upload-confirm-modal/data-import-upload-confirm-modal.component';

@Component({
  selector: 'lib-data-import',
  templateUrl: 'data-import.component.html',
  styles: []
})
export class DataImportComponent extends ExcTranslation implements OnInit, OnChanges  {

  @ContentChild('importItem') templateRef: TemplateRef<ElementRef>;
  @Input('isProvider') isProvider = false;
  client: number;
  imports: ExcImportMeta[] = [];
  constructor(private excRest: ExcRestService, private excSec: ExcSigninService) {
    super();

  }

  public refresh(clientID?: number) {
    if (clientID) {
      this.client = clientID;
    } else {
      this.client = null;
    }

    this.loadImports();
  }

  loadImports() {
    const _self = this;
    _self.imports = [];
    if (this.isProvider === true && (this.client === undefined || this.client === null)) {
      return;
    }

      const url = _self.excRest.computeUrl('DataImportR_List', {clientID: this.client});
      _self.excRest.get(url, {}).subscribe(ret => {
        if (ret) {
          _self.imports = [];
          for (const x of ret.Imports) {
            _self.imports.push(new ExcImportMeta(x));
          }
        }
      });
  }
  ngOnInit() {
    if (this.client === undefined) {
      this.client = null;
    }
    const eps = ExcCoreModule.Config().Environment.rest.Endpoints;
    if (eps['DataImportR_List'] === undefined) {
      console.log('Endpoint missing: DataImportR_List');
      alert('Endpoint missing: DataImportR_List');
    }
    if (eps['DataImportR'] === undefined) {
      console.log('Endpoint missing: DataImportR');
      alert('Endpoint missing: DataImportR');
    }
    if (eps['DataImportTemplateR'] === undefined) {
      console.log('Endpoint missing: DataImportTemplateR');
      alert('Endpoint missing: DataImportTemplateR');
    }
    if ( !this.client) {
      this.loadImports();
    }
  }

  ngOnChanges(): void {
    this.loadImports();
  }

}

export class ExcImportMeta extends ExcTranslation {
  private excRest: ExcRestService = null;
  private json: any = null;
  public ImportID: string = null;
  public Recipients: string = null;
  public client: string = null;

  private getJsonLocalized(key: string, defaultValue?: any) {
    if (this.json[this.currentLang()] !== undefined && this.json[this.currentLang()] !== null) {
      if (this.json[this.currentLang()][key] !== undefined && this.json[this.currentLang()][key] !== null) {
        return this.json[this.currentLang()][key];
      }
    }
    return defaultValue || null;
  }
  public get Icon() {
    return this.getJsonLocalized('Icon', 'fa-upload');
  }
  public get IconBackground() {
    return this.getJsonLocalized('IconBackground', 'ch-secondary');
  }
  public get Help() {
    return this.getJsonLocalized('Help');
  }
  public get Description() {
    return this.getJsonLocalized('Description');
  }
  public get Title() {
    return this.getJsonLocalized('Title');
  }
  public get TemplateType() {
    return this.getJsonLocalized('TemplateType');
  }
  public get TemplateID() {
    return this.getJsonLocalized('TemplateID');
  }
  public downloadTemplate() {
    window.location.href = this.excRest.computeUrl('DataImportTemplateR', {ImportID: this.ImportID, TemplateID: this.TemplateID, clientID : this.client});
  }
  public getMailTooltip() {
    const r = this.Recipients.replace(';', ',');
    return this.getTranslation('DataImport.nRecipients', {n: r.split(',').length});
  }
  public getTemplateTypeIcon() {
    if (this.TemplateType !== null) {
      const tmpl = this.TemplateType.toUpperCase();
      if (tmpl === 'XLSX' || tmpl === 'XLS') {
        return 'fa-file-excel';
      } else if (tmpl === 'DOCX' || tmpl === 'DOC') {
        return 'fa-file-word';
      } else {
        return 'fa-file';
      }
    }
    return '';
  }
  public showHelp(e) {
    e.stopPropagation();
    ExcCoreModule.showModal(this.Help, this.Title, 'l', null, false, []).subscribe();

  }
  public showEditMails(e) {
    const _self = this;
    e.stopPropagation();
    ExcCoreModule.showModal(DataImportEditMailModalComponent, null, 'l', this, false, null).subscribe(ret => {
      if (ret && ret.proceed === true) {
        const url = _self.excRest.computeUrl('DataImportU_Recipients', {ImportID: this.ImportID});
        _self.excRest.post(url, {Recipients: ret.Recipients}, {}).subscribe(r => {
          if (r) {
            this.Recipients = ret.Recipients;
          }
        });
      }
    });
  }
  public upload(e) {
    const _self = this;
    const file: ExcFileItem = e[0];
    const url = _self.excRest.computeUrl('DataImportR', {ImportID: this.ImportID, clientID: this.client});
    ExcCoreModule.showModal(DataImportUploadConfirmModalComponent, null, 's', file.fullName, false, null).subscribe( dlg => {
      if (dlg && dlg.proceed === true) {
        const formData = new FormData();
        formData.append('file[]', file.asBlob, file.fullName);
        _self.excRest.put(url, formData, {}).subscribe(ret => {
          ExcCoreModule.showModal(_self.getTranslation('DataImport.UploadSuccessBody'), _self.getTranslation('DataImport.UploadSuccessHeader'), 's', null, false, []).subscribe();
        });
      } else {
        e = [];
      }
    });
  }
  constructor(dataRow: any) {
    super();
    this.excRest = ExcCoreModule.Services().ExcRest;
    if (dataRow !== undefined && dataRow !== null) {
      this.json = JSON.parse(dataRow['Data']);
      this.client = dataRow['ClientID'];
      this.Recipients = dataRow['Recipients'];
      this.ImportID = dataRow['ImportID'];
    }
  }
}
